export const NETWORK_CHAIN_IDS = {
  MAINNET: 1,
  GOERLI: 5,
};

export const mainnetId =
  process.env.NODE_ENV === "production"
    ? NETWORK_CHAIN_IDS.MAINNET
    : NETWORK_CHAIN_IDS.GOERLI;
